// extracted by mini-css-extract-plugin
export default {"tooltip":"u__H1upev43M6OJeLK_x"};